(function (){
    angular.module('myApp').factory('systemService', ['briefcaseConstants',
        function (briefcaseConstants){
            return new SystemClient.SystemService(briefcaseConstants.BASE_URL2 + '/v2');
        }])
})();